/**
 * Locale française de PrimeVue, fusionnée avec la locale par défaut (clés absentes : anglais d'origine).
 * Calendriers en français et commençant le lundi, libellés accessibles des composants.
 */
export const PRIMEVUE_FR = {
  startsWith: 'Commence par',
  contains: 'Contient',
  notContains: 'Ne contient pas',
  endsWith: 'Se termine par',
  equals: 'Égal à',
  notEquals: 'Différent de',
  noFilter: 'Aucun filtre',
  clear: 'Effacer',
  apply: 'Appliquer',
  accept: 'Oui',
  reject: 'Non',
  choose: 'Choisir',
  upload: 'Téléverser',
  cancel: 'Annuler',
  completed: 'Terminé',
  pending: 'En attente',
  dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
  dayNamesShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
  dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  // Majuscule : ils s'affichent seuls en tête de calendrier et dans le choix du mois
  monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
  chooseYear: 'Choisir l’année',
  chooseMonth: 'Choisir le mois',
  chooseDate: 'Choisir la date',
  prevDecade: 'Décennie précédente',
  nextDecade: 'Décennie suivante',
  prevYear: 'Année précédente',
  nextYear: 'Année suivante',
  prevMonth: 'Mois précédent',
  nextMonth: 'Mois suivant',
  prevHour: 'Heure précédente',
  nextHour: 'Heure suivante',
  prevMinute: 'Minute précédente',
  nextMinute: 'Minute suivante',
  prevSecond: 'Seconde précédente',
  nextSecond: 'Seconde suivante',
  today: 'Aujourd’hui',
  weekHeader: 'Sem.',
  firstDayOfWeek: 1,
  dateFormat: 'dd/mm/yy',
  emptyFilterMessage: 'Aucun résultat',
  searchMessage: '{0} résultat(s)',
  selectionMessage: '{0} élément(s) sélectionné(s)',
  emptySelectionMessage: 'Aucun élément sélectionné',
  emptySearchMessage: 'Aucun résultat',
  emptyMessage: 'Aucune option disponible',
  aria: {
    trueLabel: 'Vrai',
    falseLabel: 'Faux',
    nullLabel: 'Non sélectionné',
    star: '1 étoile',
    stars: '{star} étoiles',
    selectAll: 'Tout sélectionner',
    unselectAll: 'Tout désélectionner',
    close: 'Fermer',
    previous: 'Précédent',
    next: 'Suivant',
    navigation: 'Navigation',
    scrollTop: 'Remonter en haut',
    listView: 'Vue liste',
    gridView: 'Vue grille',
    slide: 'Diapositive',
    slideNumber: '{slideNumber}',
    zoomImage: 'Agrandir l’image',
    zoomIn: 'Zoomer',
    zoomOut: 'Dézoomer',
    rotateRight: 'Pivoter à droite',
    rotateLeft: 'Pivoter à gauche',
    listLabel: 'Liste d’options',
  },
}
